import { forwardRef } from 'react'

const ModalContentWrapper = forwardRef(
    ({ children, spacing = 'normal', size = '3xl' }, ref) => {
        const sizeClasses = {
            md: 'max-w-md',
            xl: 'max-w-xl',
            '2xl': 'max-w-2xl',
            '3xl': 'max-w-3xl',
            '4xl': 'max-w-4xl',
            '5xl': 'max-w-5xl',
        }

        const spacingClasses = {
            small: 'my-4',
            normal: 'my-8',
            large: 'my-12',
        }

        return (
            <div
                ref={ref}
                className={`inline-block w-full ${
                    sizeClasses[size] || sizeClasses['3xl']
                } ${
                    spacingClasses[spacing] || spacingClasses.normal
                } overflow-hidden rounded-2xl bg-white align-middle shadow-[0_24px_60px_rgba(26,29,35,0.18)] transition-all transform`}>
                {children}
            </div>
        )
    },
)

ModalContentWrapper.displayName = 'ModalContentWrapper'

export default ModalContentWrapper
